import { Howl } from 'howler';

const TYPES = [
    {
        id: 'notification',
        src: ['/media/notification.mp3']
    }
];

const sounds = TYPES.map(({ id, src }) => {
    const audio = new Howl({ src });

    return { id, audio };
});

const getSoundById = id => sounds.find(sound => sound.id === id);

export const playSound = id => {
    const sound = getSoundById(id);

    if (!sound) {
        return;
    }

    sound.audio.play();
}

export const playThrottledSound = id => {
    const sound = getSoundById(id);

    if (!sound) {
        return;
    }

    if (sound.audio.playing()) {
        return;
    }

    sound.audio.play();
}

export const stopSound = id => {
    const sound = getSoundById(id);

    if (!sound) {
        return;
    }

    sound.audio.stop();
}
